import { TokenLogos } from '../assets/tokenLogos';

// Network configuration
export const FANTOM_NETWORK = {
  chainId: '0xfa', // 250 in hex
  chainName: 'Fantom Opera',
  nativeCurrency: {
    name: 'FTM',
    symbol: 'FTM',
    decimals: 18,
  },
  rpcUrls: ['https://rpc.fantom.network'],
  blockExplorerUrls: ['https://ftmscan.com/'],
};

// Contract addresses
export const CONTRACTS = {
  SWAPPER: process.env.REACT_APP_SWAPPER_ADDRESS || '0xcBc0C8919f95688b400723Bc742575723EF25074',
  VAULT: process.env.REACT_APP_VAULT_ADDRESS || '0x4E8d6150c1C1f453cc41431231189b8BDe88740F',
  ROUTER: '0x6D0176C5ea1e44b08D3dd001b0784cE42F47a3A7',
  FACTORY: '0xE236f6890F1824fa0a7ffc39b1597A5A6077Cfe9',
};

// Token addresses and configurations
export const TOKENS = {
  FTM: {
    address: '0x0000000000000000000000000000000000000000', // Native FTM
    symbol: 'FTM',
    name: 'Fantom',
    decimals: 18,
    logo: TokenLogos.FTM,
    isNative: true,
  },
  WFTM: {
    address: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    symbol: 'WFTM',
    name: 'Wrapped Fantom',
    decimals: 18,
    logo: TokenLogos.WFTM,
    isNative: false,
  },
  LIF3: {
    address: '0xbf60e7414EF09026733c1E7de72E7393888C64DA',
    symbol: 'LIF3',
    name: 'Lif3 (Old)',
    decimals: 18,
    logo: TokenLogos.LIF3,
    isNative: false,
  },
  LSHARE: {
    address: '0xCbE0CA46399Af916784cADF5bCC3aED2052D6C45',
    symbol: 'LSHARE',
    name: 'LSHARE (Old)',
    decimals: 18,
    logo: TokenLogos.LSHARE,
    isNative: false,
  },
};

// Get token list as array
export const TOKEN_LIST = Object.values(TOKENS);

// Get token by address
export const getTokenByAddress = (address) => {
  return TOKEN_LIST.find(token => 
    token.address.toLowerCase() === address.toLowerCase()
  );
};

// Get token by symbol
export const getTokenBySymbol = (symbol) => {
  return TOKEN_LIST.find(token => 
    token.symbol.toLowerCase() === symbol.toLowerCase()
  );
};

// Trading pairs configuration
export const TRADING_PAIRS = [
  { from: 'FTM', to: 'WFTM' },
  { from: 'WFTM', to: 'FTM' },
  { from: 'FTM', to: 'LIF3' },
  { from: 'LIF3', to: 'FTM' },
  { from: 'FTM', to: 'LSHARE' },
  { from: 'LSHARE', to: 'FTM' },
  { from: 'WFTM', to: 'LIF3' },
  { from: 'LIF3', to: 'WFTM' },
  { from: 'WFTM', to: 'LSHARE' },
  { from: 'LSHARE', to: 'WFTM' },
  { from: 'LIF3', to: 'LSHARE' },
  { from: 'LSHARE', to: 'LIF3' },
];

// Default slippage settings
export const SLIPPAGE_OPTIONS = [
  { label: '0.1%', value: 0.1 },
  { label: '0.5%', value: 0.5 },
  { label: '1%', value: 1 },
  { label: '2%', value: 2 },
  { label: '5%', value: 5 },
];

export const DEFAULT_SLIPPAGE = 1.0; // 1.0%
export const FEE_PERCENTAGE = 1; // 1% fee

// Contract address exports for components
export const VAULT_ADDRESS = CONTRACTS.VAULT;
export const SWAPPER_ADDRESS = CONTRACTS.SWAPPER;

// Supported tokens for easy iteration
export const SUPPORTED_TOKENS = TOKENS;